module.exports = __webpack_public_path__ + "assets/images/project/changi-village/01.jpg?v=d70a9d5f";